import axiosInstance from './AxiosInstance';

const API_URL = 'user';

export const getUsers = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching users', error);
        throw error;
    }
};

export const getUserById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching user with id ${id}`, error);
        throw error;
    }
};

export const createUser = async (user) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, user);
        return response.data;
    } catch (error) {
        console.error('Error creating user', error);
        throw error;
    }
};

export const inviteExternalUser = async (payload) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/invite-external`, payload);
        return response.data;
    } catch (error) {
        console.error('Error inviting external user', error);
        throw error;
    }
};

export const resendExternalInvite = async (payload) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/resend-external-invite`, payload);
        return response.data;
    } catch (error) {
        console.error('Error re-inviting external user', error);
        throw error;
    }
};

export const updateUser = async (id, user) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...user });
        return response.data;
    } catch (error) {
        console.error(`Error updating user with id ${id}`, error);
        throw error;
    }
};

export const deleteUser = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting user with id ${id}`, error);
        throw error;
    }
};

export const bulkDeleteUsers = async (ids) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/bulk-delete`, { ids });
        return response.data;
    } catch (error) {
        console.error('Error bulk deleting users', error);
        throw error;
    }
};

export const bulkResendExternalInvite = async (emails) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/bulk-resend-external-invite`, { emails });
        return response.data;
    } catch (error) {
        console.error('Error bulk re-inviting external users', error);
        throw error;
    }
};

export const getUserJoiningDate = async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/joining-date/${email}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching user with email ${email}`, error);
        return {dateOfJoining: '', isError: true };
    }
};

export const getUserAwardInfo = async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/award-amount/${email}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching award info user with email ${email}`, error);
        return {totalAwardAmount: '' ,usedAwardAmount:'' , isError: true };
    }
};

export const getUserTuitionInfo = async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/tuition-amount/${email}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching tuition user with email ${email}`, error);
        return {totalTuitionAmount: '' ,usedTuitionAmount:'' , isError: true };
    }
};

export const updateUserFromExcel = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/import-user-excel`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        return response.data;
    } catch (error) {
        console.error('Error import-user-excel user', error);
        throw error;
    }
};
